// src/data/norwegianInventory.js
// Canonical Norwegian inventory for the tiles/grid.
// This is the SAME for all languages.

export const NORWEGIAN_INVENTORY = {
  consonants: [
    { ipa: "p", no: ["på"] },
    { ipa: "b", no: ["bi"] },
    { ipa: "t", no: ["tå"] },
    { ipa: "d", no: ["deg"] },
    { ipa: "ʈ", no: ["smart"] },
    { ipa: "ɖ", no: ["ferdig"] },
    { ipa: "k", no: ["kåt"] },
    { ipa: "ɡ", no: ["glass"] },
    { ipa: "m", no: ["min"] },
    { ipa: "n", no: ["nei"] },
    { ipa: "ɳ", no: ["barna"] },
    { ipa: "ŋ", no: ["ring"] },
    { ipa: "f", no: ["fiks"] },
    // canonical Norwegian v-sound:
    { ipa: "ʋ", no: ["vest"] },
    { ipa: "s", no: ["si"] },
    { ipa: "ʃ", no: ["ski"] },
    { ipa: "ç", no: ["kjapp"] },
    { ipa: "j", no: ["jet"] },
    { ipa: "h", no: ["hi"] },
    { ipa: "r", no: ["rein", "verre"] },
    { ipa: "l", no: ["lin"] },
    { ipa: "ɭ", no: ["jarl"] },
  ],

  vowels: [
    { ipa: "i", no: ["sinn"] },
    { ipa: "iː", no: ["mi"] },
    { ipa: "y", no: ["synd"] },
    { ipa: "yː", no: ["lys"] },
    { ipa: "e", no: ["send"] },
    { ipa: "eː", no: ["ler"] },
    { ipa: "ø", no: ["søtt"] },
    { ipa: "øː", no: ["møt"] },
    { ipa: "æ", no: ["vært"] },
    { ipa: "æː", no: ["mædi"] },
    { ipa: "ɑ", no: ["ta"] },
    { ipa: "ɑː", no: ["spa"] },
    { ipa: "ʉ", no: ["full"] },
    { ipa: "ʉː", no: ["tur"] },
    { ipa: "u", no: ["bodd"] },
    { ipa: "uː", no: ["bod"] },
    { ipa: "o", no: ["dott"] },
    { ipa: "oː", no: ["lån"] },
  ],

  diphthongs: [
    { ipa: "ɑi", no: ["hai"] },
    // canonical “ei” diphthong represented as /æi/:
    { ipa: "æi", no: ["hei"] },
    { ipa: "øy", no: ["høy"] },
    { ipa: "æʉ", no: ["sau"] },
    { ipa: "oy", no: ["soya"] },
    { ipa: "uy", no: ["hoie"] },
    { ipa: "ʉy", no: ["huie"] },
  ],
};
